// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-select-new .drop-down-trigger {
   padding: unset;
   margin: unset;
   width: 100%;
   color: var(--text);
   background-color: var(--frame-bg);
}

.ecl-select-new .drop-down-trigger:hover {
   background-color: var(--frame-bg-hovered);
}

.ecl-select-new .select-menu-trigger {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   background: transparent;
   border: var(--border);
   border-radius: var(--border-radius);
}

.select-menu-filter {
   margin-right: 0;
   margin-bottom: 5px;
}

.ecl-select-new .select-menu-trigger span {
   width: calc(100% - 30px);
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   text-align: left;
   padding-left: var(--padding);
}

.ecl-select-new .select-menu-trigger .themed-svg-container {
   width: 23px;
   height: 23px;
   padding: var(--padding-sm);
}

.ecl-select-new .select-custom-trigger {
   width: 100%;
   height: 100%;
}

.drop-down-trigger:has(.select-custom-trigger) {
   padding: var(--padding-sm);
}

/* WEIRD CSS LOCATION BC IT'S IN THE PORTAL CONTAINER */

.drop-down-container .singleselect-list-container,
.drop-down-container .multiselect-list-container {
   display: flex;
   flex-direction: column;
   width: 100%;
}

.singleselect-list-container .select-option,
.multiselect-list-container .select-option {
   background-color: unset;
   border-radius: unset;
   text-align: left;
   color: var(--text);
   height: unset;
   margin: unset;
}

@media (max-width: 769px) and (orientation: portrait),
(max-height: 769px) and (orientation: landscape) {
   .singleselect-list-container .select-option {
      height: 40px
   }
}


.drop-down-container .singleselect-list-container .select-option:hover,
.drop-down-container .multiselect-list-container .select-option:hover {
   background-color: var(--button-primary-hovered)
}

.drop-down-container .singleselect-list-container .select-option p,
.drop-down-container .multiselect-list-container .select-option p {
   margin: unset;
   padding: unset;
}

.drop-down-container .multiselect-list-container label {
   width: 100%;
   cursor: pointer;
}

.drop-down-container .multiselect-list-container .multiselect-control-container {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.drop-down-container .multiselect-list-container .multiselect-control-container button {
   width: 33%
}


.drop-down-container .multiselect-list-container .multiselect-control-container p {
   text-align: center;
}

.multiselect-list-container label {
   font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLSelect/ECLSelect.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,aAAa;GACb,WAAW;GACX,kBAAkB;GAClB,iCAAiC;AACpC;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,mBAAmB;GACnB,uBAAuB;GACvB,qBAAqB;GACrB,mCAAmC;AACtC;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,gBAAgB;GAChB,4BAA4B;AAC/B;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,0BAA0B;AAC7B;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA;GACG,0BAA0B;AAC7B;;AAEA,uDAAuD;;AAEvD;;GAEG,aAAa;GACb,sBAAsB;GACtB,WAAW;AACd;;AAEA;;GAEG,uBAAuB;GACvB,oBAAoB;GACpB,gBAAgB;GAChB,kBAAkB;GAClB,aAAa;GACb,aAAa;AAChB;;AAEA;;GAEG;MACG;GACH;AACH;;;AAGA;;GAEG;AACH;;AAEA;;GAEG,aAAa;GACb,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG;AACH;;;AAGA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB","sourcesContent":[".ecl-select-new .drop-down-trigger {\r\n   padding: unset;\r\n   margin: unset;\r\n   width: 100%;\r\n   color: var(--text);\r\n   background-color: var(--frame-bg);\r\n}\r\n\r\n.ecl-select-new .drop-down-trigger:hover {\r\n   background-color: var(--frame-bg-hovered);\r\n}\r\n\r\n.ecl-select-new .select-menu-trigger {\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n   background: transparent;\r\n   border: var(--border);\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.select-menu-filter {\r\n   margin-right: 0;\r\n   margin-bottom: 5px;\r\n}\r\n\r\n.ecl-select-new .select-menu-trigger span {\r\n   width: calc(100% - 30px);\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   text-align: left;\r\n   padding-left: var(--padding);\r\n}\r\n\r\n.ecl-select-new .select-menu-trigger .themed-svg-container {\r\n   width: 23px;\r\n   height: 23px;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.ecl-select-new .select-custom-trigger {\r\n   width: 100%;\r\n   height: 100%;\r\n}\r\n\r\n.drop-down-trigger:has(.select-custom-trigger) {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n/* WEIRD CSS LOCATION BC IT'S IN THE PORTAL CONTAINER */\r\n\r\n.drop-down-container .singleselect-list-container,\r\n.drop-down-container .multiselect-list-container {\r\n   display: flex;\r\n   flex-direction: column;\r\n   width: 100%;\r\n}\r\n\r\n.singleselect-list-container .select-option,\r\n.multiselect-list-container .select-option {\r\n   background-color: unset;\r\n   border-radius: unset;\r\n   text-align: left;\r\n   color: var(--text);\r\n   height: unset;\r\n   margin: unset;\r\n}\r\n\r\n@media (max-width: 769px) and (orientation: portrait),\r\n(max-height: 769px) and (orientation: landscape) {\r\n   .singleselect-list-container .select-option {\r\n      height: 40px\r\n   }\r\n}\r\n\r\n\r\n.drop-down-container .singleselect-list-container .select-option:hover,\r\n.drop-down-container .multiselect-list-container .select-option:hover {\r\n   background-color: var(--button-primary-hovered)\r\n}\r\n\r\n.drop-down-container .singleselect-list-container .select-option p,\r\n.drop-down-container .multiselect-list-container .select-option p {\r\n   margin: unset;\r\n   padding: unset;\r\n}\r\n\r\n.drop-down-container .multiselect-list-container label {\r\n   width: 100%;\r\n   cursor: pointer;\r\n}\r\n\r\n.drop-down-container .multiselect-list-container .multiselect-control-container {\r\n   display: flex;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.drop-down-container .multiselect-list-container .multiselect-control-container button {\r\n   width: 33%\r\n}\r\n\r\n\r\n.drop-down-container .multiselect-list-container .multiselect-control-container p {\r\n   text-align: center;\r\n}\r\n\r\n.multiselect-list-container label {\r\n   font-weight: normal;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
